import React from 'react';
import { useTranslation } from 'react-i18next';
import { isLanguageLoaded, loadLanguage } from '../../../i18n/config';

const PageContext = React.createContext({});

export const PageContextProvider = ({ pageContext, children }) => {
  const { i18n } = useTranslation();
  if(i18n.language !== pageContext.lang) { // fix too man rerenders
    // Navigating into another language: keep the current strings until its chunk is in.
    if (isLanguageLoaded(pageContext.lang)) i18n.changeLanguage(pageContext.lang);
    else loadLanguage(pageContext.lang).then(() => i18n.changeLanguage(pageContext.lang));
  }

  return <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>;
};

export const usePageContext = () => React.useContext(PageContext);
